<template>
  <div class="form-certification">
    <edit-table
      :option="option"
      :data="form"
      @submit-add="handleSubmit"
      @submit-edit="handleSubmit"
      @rowDel="handleRowDel"
    >
      <template slot="header">
        <my-tooltip :tooltip="'班组管理'">
          <b-button
            v-if="employment.isSupervisor"
            variant="primary"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleTeamOpen('Teams')"
          >
            <feather-icon size="18" icon="PauseIcon" />
          </b-button>
        </my-tooltip>
      </template>
      <!-- <template slot="">

      </template> -->
    </edit-table>
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue'
import { deepClone } from '@/util/util'
import WORKER from '@/api/worker/index'

import { BButton } from 'bootstrap-vue'

export default {
  components: {
    EditTable,
    BButton,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    employment: {
      type: Array,
      default: () => {},
    },
    teamList: {
      type: Array,
      default: () => {},
    },
    detailType: {
      type: String,
      default: 'view',
    },
  },
  data() {
    return {
      teamsData: [],
      hasToStringTypes: ['select'],
    }
  },
  computed: {
    option() {
      const option = {
        drawer: true,
        menu: false,
        addBtn: false,
        editBtn: this.detailType !== 'view',
        refresh: false,
        columns: [
          {
            label: this.i18n('name'),
            field: 'name',
          },
          // {
          //   label: 'Status',
          //   field: 'status',
          //   formOption: {
          //     // type: 'select',
          //     // dictCode: 'unit',
          //   },
          // },
          {
            label: this.i18n('joinDate'),
            field: 'teamJoinDate',
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd hh:mm:ss',
            dateOutputFormat: 'MMM do yy',
          },
          // {
          //   label: this.i18n('leftDate'),
          //   field: 'teamLeftDate',
          //   type: 'date',
          //   dateInputFormat: 'yyyy-MM-dd hh:mm:ss',
          //   dateOutputFormat: 'MMM do yy',
          // },
          // {
          //   label: this.i18n('remark'),
          //   field: 'remark',
          // },
        ],
      }
      return option
    },
    form() {
      const res = []

      this.teamsData.forEach((row) => {
        const temp = row
        this.option.columns.forEach((item) => {
          if (this.hasToStringTypes.indexOf(item.type) !== -1) {
            temp[item.field] = row[item.field].toString()
          }
        })
        res.push(temp)
      })
      return res
    },
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    // 国际化
    i18n(param) {
      // return this.$t(`_staff.labelProject.${param}`)
      return this.$t(`_worker.teams.${param}`)
    },
    handleTeamOpen(key) {
      this.$router.push({ path: '/worker/teams/index' })
    },
    handleSubmit(done, row) {
      setTimeout(() => {
        done()
      }, 3000)
    },
    handleRowDel(done, row) {
      setTimeout(() => {
        done()
      }, 3000)
    },
    async refreshChange() {
      const res = await WORKER.getList(1)
      console.log(res, 'work team')
      this.teamsData = res.data.data.records
    },
    onLoad() {
      this.teamsData = deepClone(this.teamList)
    },
  },
}
</script>
<style lang="scss">
.form-certification {
  &-top {
    text-align: right;
  }
  .table-td {
    text-align: center;
    line-height: 50px;
    &-sm {
      width: 200px;
    }
  }
}
</style>
